import { http } from '@/shared/api'
import type { ApiSingleResponse } from '@/shared/api'
import type { ReadOptions } from '@/shared/lib'
import { API } from '@/apps/adok/shared/api'

import type { ApiAccess } from '../model/types'

/** Hand-written rather than `createEntityApi`: a singular resource, no id in its path. */
export const getApiAccess = (options?: ReadOptions) =>
  http.get<ApiSingleResponse<ApiAccess>>(API.apiAccess, {
    signal: options?.signal
  })

export const enableApiAccess = () =>
  http.post<ApiSingleResponse<ApiAccess>>(API.apiAccess)

export const rotateApiAccess = () =>
  http.post<ApiSingleResponse<ApiAccess>>(`${API.apiAccess}/rotate`)

export const disableApiAccess = () =>
  http.delete<ApiSingleResponse<ApiAccess>>(API.apiAccess)
